import classes from "./PlayerList.module.css";

import Avatar from "../UI/Avatar";
import Crown from "../UI/Crown";
import React from "react";

const PlayerList = (props) => {
  // Build a name→token lookup from tableData so we can send tokens to the kick handler
  const tokenByName = props.tableData
    ? Object.fromEntries(props.tableData.map((p) => [p.name, p.id]))
    : {};

  return (
    <div style={{height: props.tutorialStep === 1 && "100%"}} className={classes.panel}>
      <section className={classes.content}>
        <h3>{`${props.usersName.length} Players`}</h3>
        {props.admin && (
          <div data-player={props.admin.name} className={classes.user} style={{ alignItems: "stretch" }}>
            <Avatar id={props.admin.avatar} />
            <section className={classes.adminBuilder}>
              <p className={classes.adminName}>{props.admin.name}</p>
              <Crown/>
              {props.owner && props.admin.name === props.owner.name && (
                <p className={classes.adminText}>you</p>
              )}
            </section>
          </div>
        )}
        <hr />
        {props.usersList.length === 0 ? (
          <p className={classes.inviteText}>
            Invite other players to join room
          </p>
        ) : (
          props.usersList.map((e) => (
            <div
              key={e.name}
              data-player={e.name}
              className={classes.user}
              style={{marginTop:"1.5vw"}}
            >
              <Avatar id={e.avatar} />
              <section className={classes.adminBuilder}>
                <p className={classes.notAdmin} key={e.name}>
                  {e.name}
                </p>
                {props.owner && props.owner.name === e.name && (
                  <p className={classes.adminText}>you</p>
                )}
              </section>
              {props.isAdmin && props.myToken !== tokenByName[e.name] && props.onKickPlayer && (
                <button onClick={() => props.onKickPlayer(tokenByName[e.name])}>Remove</button>
              )}
            </div>
          ))
        )}
      </section>
    </div>
  );
};

export default PlayerList;
